
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

interface LocationDetailProps {
  locationName: string;
  description: React.ReactNode;
  imageSrc: string;
  imageAlt?: string;
}

const LocationDetail = ({
  locationName,
  description,
  imageSrc,
  imageAlt,
}: LocationDetailProps) => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6">
              Klaverundervisning i <span className="text-piano-gold">{locationName}</span>
            </h2>
            {typeof description === 'string' ? (
              <p className="text-lg text-gray-700 mb-8">{description}</p>
            ) : (
              description
            )}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild className="bg-piano-gold hover:bg-piano-gold/90 text-white">
                <Link to="/kontakt">Book gratis prøvetime</Link>
              </Button>
              <Button asChild variant="outline">
                <Link to="/undervisning">Se undervisningstilbud</Link>
              </Button>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-piano-gold to-amber-400 rounded-lg blur opacity-20"></div>
            <div className="relative bg-white p-3 rounded-lg shadow-xl">
              <div className="aspect-square bg-gray-100 rounded-md overflow-hidden">
                <img 
                  src={imageSrc} 
                  alt={imageAlt || `Klaverundervisning i ${locationName}`} 
                  className="w-full h-full object-cover object-center object-[50%_35%]"
                  width="400"
                  height="400"
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(LocationDetail);
